/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTrfV1TrfSessionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRF_V1_TRF_SESSION_STATE_ENTITY_NAME = 'ixc.trf.v1.TrfSession';
export const ixcTrfV1TrfSessionStateEntity = new schema.Entity<IxcTrfV1TrfSessionState>(IXC_TRF_V1_TRF_SESSION_STATE_ENTITY_NAME, {}, { idAttribute: 'sessionId' });

